interface UnitsInterface {
  general: string;
  glucose: string;
}

interface HeightInterface {
  feet: number;
  inches: number;
}

export interface memberObject {
  id: string;
  email: string;
  externId: string;
  firstName: string;
  lastName: string;
  username: string;
  program?: string;
  phone?: string;
  groups?: [string];
  site?: string;
  birthDate?: string;
  gender?: string;
  language?: string;
  condition?: string;
  estimatedGraduation?: string;
  height?: HeightInterface;
  weight?: number;
  status?: string;
  units?: UnitsInterface;
  locked?: boolean;
  latestReading?: string;
  mostRecentReading: object;
}

export interface memberContextInterface {
  cid?: string;
  current: memberObject;
  isCoordinator: boolean;
  url: string | null;
  list: memberObject[];
  items: memberObject[];
  encounterStart: string;
  secondsCounter: number;
  notesContent: string;
  noteOpen: boolean;
  recents: any;
}

export const memberContext = {
  current: {
    id: "",
    email: "",
    externId: "",
    firstName: "",
    lastName: "",
    username: ""
  },
  isCoordinator: false,
  url: "",
  list: [],
  encounterStart: "00:00",
  secondsCounter: 0,
  notesContent: "",
  noteOpen: false,
  recents: null
};
